/**
 * sticky-atc.js
 * Drop into: assets/sticky-atc.js
 * Link in theme.liquid (before </body>):
 *   <script src="{{ 'sticky-atc.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────────
   * CONFIG — tweak these values to match your store
   * ───────────────────────────────────────────────────────────────────── */
  var CONFIG = {
    // CSS selector for the native Add-to-Cart button on the product page
    nativeAtcSelector: '[name="add"], .product-form__submit, .btn-addtocart',
    // CSS selector for the native variant selector <select>
    variantSelectSelector: '[name="id"]',
    // Max recently viewed items stored
    rvMax: 8,
    // Recently viewed localStorage key
    rvKey: 'satc_rv_products',
  };

  /* ─────────────────────────────────────────────────────────────────────
   * UTILITIES
   * ───────────────────────────────────────────────────────────────────── */
  function $(id) { return document.getElementById(id); }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.satcMoneyFormat || '₹{{amount}}');
    }
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  /* ─────────────────────────────────────────────────────────────────────
   * TOAST
   * ───────────────────────────────────────────────────────────────────── */
  var toastTimer = null;
  var lastAdded  = null;

  function showToast(msg, showUndo) {
    var toast = $('satc-toast');
    var undo  = $('satc-toast-undo');
    if (!toast) return;
    $('satc-toast-msg').textContent = msg;
    undo.style.display = showUndo ? '' : 'none';
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 3200);
  }

  function hideToast() {
    var toast = $('satc-toast');
    if (toast) toast.classList.remove('is-visible');
  }

  window.satcUndoLast = function () {
    if (!lastAdded) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lastAdded.key, quantity: lastAdded.prevQty }),
    })
    .then(function () { satcRefreshDrawer(); hideToast(); lastAdded = null; })
    .catch(function (err) { console.error('[satc] undo failed', err); });
  };

  /* ─────────────────────────────────────────────────────────────────────
   * COUNTDOWN TIMER
   * ───────────────────────────────────────────────────────────────────── */
  function initTimer() {
    var timerEl = $('satc-timer');
    if (!timerEl) return;

    var endTimeStr = timerEl.dataset.end;
    if (!endTimeStr) return;

    var endTime = new Date(endTimeStr).getTime();
    if (isNaN(endTime)) return;

    var elH = $('satc-t-h');
    var elM = $('satc-t-m');
    var elS = $('satc-t-s');

    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        timerEl.classList.add('is-expired');
        return;
      }
      var totalSec = Math.floor(diff / 1000);
      elH.textContent = pad(Math.floor(totalSec / 3600));
      elM.textContent = pad(Math.floor((totalSec % 3600) / 60));
      elS.textContent = pad(totalSec % 60);
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ─────────────────────────────────────────────────────────────────────
   * STICKY BAR — show/hide via IntersectionObserver
   * ───────────────────────────────────────────────────────────────────── */
  function initStickyBar() {
    var bar = $('satc-bar');
    if (!bar) return;

    var nativeAtc = document.querySelector(CONFIG.nativeAtcSelector);
    if (!nativeAtc) return;

    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(nativeAtc);

    $('satc-bar-atc').addEventListener('click', function () { satcAddToCart(); });
    $('satc-bar-buy').addEventListener('click', function () { satcBuyNow(); });
  }

  /* ─────────────────────────────────────────────────────────────────────
   * VARIANT SYNC — updates sticky bar label and price on variant change
   * ───────────────────────────────────────────────────────────────────── */
  function initVariantSync() {
    var variants = window.satcVariants || [];

    function updateBar(variantId) {
      var variant = variants.find(function (v) { return v.id == variantId; });
      if (!variant) return;

      var labelEl = $('satc-bar-variant');
      var priceEl = $('satc-bar-price');
      if (labelEl) {
        labelEl.textContent = variant.title !== 'Default Title' ? variant.title : '';
      }
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      // Store current variant id for add-to-cart
      if ($('satc-bar')) {
        $('satc-bar').dataset.variantId = variantId;
      }

      var atcBtn = $('satc-bar-atc');
      var buyBtn = $('satc-bar-buy');
      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to cart';
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'SOLD OUT';
        }
      }
      if (buyBtn) {
        if (variant.available) {
          buyBtn.style.display = '';
        } else {
          buyBtn.style.display = 'none';
        }
      }
    }

    // Listen for native select changes
    document.addEventListener('change', function (e) {
      if (e.target.matches(CONFIG.variantSelectSelector)) {
        setTimeout(function () { updateBar(e.target.value); }, 30);
      }
    });

    // Support themes that dispatch custom variant:change events
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) updateBar(e.detail.variant.id);
    });

    // Some themes fire this on window
    window.addEventListener('variantChange', function (e) {
      if (e.detail && e.detail.variant) updateBar(e.detail.variant.id);
    });

    // Seed with current selected variant
    var sel = document.querySelector(CONFIG.variantSelectSelector);
    if (sel) updateBar(sel.value);
  }

  /* ─────────────────────────────────────────────────────────────────────
   * ADD TO CART (AJAX)
   * ───────────────────────────────────────────────────────────────────── */
  function getSelectedVariantId() {
    var bar = $('satc-bar');
    if (bar && bar.dataset.variantId) return bar.dataset.variantId;
    var sel = document.querySelector(CONFIG.variantSelectSelector);
    return sel ? sel.value : null;
  }

  function satcAddToCart(variantId, openDrawer, title) {
    variantId = variantId || getSelectedVariantId();
    if (!variantId) { alert('Please select a variant first.'); return; }
    
    var variant = (window.satcVariants || []).find(function(v) { return v.id == variantId; });
    if (variant && !variant.available) return; // Prevent request if sold out
    
    openDrawer = openDrawer !== false;

    var atcBtn = $('satc-bar-atc');
    if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(function (res) {
      if (!res.ok) throw new Error('add to cart failed');
      return res.json();
    })
    .then(function (item) {
      lastAdded = { key: item.key, prevQty: Math.max(0, item.quantity - 1) };
      var msg = (title || item.title) + ' added';
      showToast(msg, true);
      if (openDrawer) {
        satcRefreshDrawer().then(function () { satcOpenDrawer(); });
      } else {
        satcRefreshDrawer();
      }
      // Dispatch event so other theme scripts (cart bubble etc.) can react
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(function (err) {
      console.error('[satc] add to cart error', err);
      alert('Something went wrong. Please try again.');
    })
    .finally(function () {
      if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = 'Add to cart'; }
    });
  }

  function satcBuyNow() {
    var variantId = getSelectedVariantId();
    if (!variantId) { alert('Please select a variant first.'); return; }
    window.location.href = '/checkout?variant=' + variantId;
  }

  /* ─────────────────────────────────────────────────────────────────────
   * DRAWER OPEN / CLOSE
   * ───────────────────────────────────────────────────────────────────── */
  function satcOpenDrawer() {
    var drawer  = $('satc-drawer');
    var overlay = $('satc-overlay');
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.focus();
  }

  window.satcCloseDrawer = function () {
    var drawer  = $('satc-drawer');
    var overlay = $('satc-overlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.satcCloseDrawer();
  });

  /* ─────────────────────────────────────────────────────────────────────
   * REFRESH DRAWER — fetch /cart.js and re-render everything
   * ───────────────────────────────────────────────────────────────────── */
  function satcRefreshDrawer() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderItems(cart);
        updateShippingBar(cart.total_price);
        renderRecentlyViewed();
      })
      .catch(function (err) { console.error('[satc] cart refresh error', err); });
  }

  /* ─────────────────────────────────────────────────────────────────────
   * RENDER CART ITEMS
   * ───────────────────────────────────────────────────────────────────── */
  function renderItems(cart) {
    var container = $('satc-items');
    var totalEl   = $('satc-total');
    var countEl   = $('satc-count');
    if (!container) return;

    if (totalEl)  totalEl.textContent  = formatMoney(cart.total_price);
    if (countEl)  countEl.textContent  = cart.item_count ? '(' + cart.item_count + ')' : '';

    if (!cart.item_count) {
      container.innerHTML = '<p class="satc-items__empty">Your cart is empty</p>';
      return;
    }

    container.innerHTML = cart.items.map(function (item) {
      return [
        '<div class="satc-item">',
          '<img class="satc-item__img"',
               ' src="' + (item.image || '') + '"',
               ' alt="' + (item.title || '').replace(/"/g, '&quot;') + '"',
               ' width="54" height="54" loading="lazy">',
          '<div class="satc-item__info">',
            '<p class="satc-item__title">' + (item.product_title || item.title) + '</p>',
            item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="satc-item__variant">' + item.variant_title + '</p>'
              : '',
            '<div class="satc-qty">',
              '<button type="button" class="satc-qty__btn"',
                ' data-key="' + item.key + '" data-delta="-1"',
                ' aria-label="Decrease quantity">&#x2212;</button>',
              '<span class="satc-qty__num">' + item.quantity + '</span>',
              '<button type="button" class="satc-qty__btn"',
                ' data-key="' + item.key + '" data-delta="1"',
                ' aria-label="Increase quantity">+</button>',
            '</div>',
          '</div>',
          '<span class="satc-item__price">' + formatMoney(item.final_line_price) + '</span>',
        '</div>',
      ].join('');
    }).join('');
  }

  // Qty change via event delegation
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.satc-qty__btn');
    if (!btn) return;
    var key   = btn.dataset.key;
    var delta = parseInt(btn.dataset.delta, 10);
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items.find(function (i) { return i.key === key; });
        if (!item) return;
        var newQty = Math.max(0, item.quantity + delta);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty }),
        });
      })
      .then(function () { satcRefreshDrawer(); })
      .catch(function (err) { console.error('[satc] qty change error', err); });
  });

  /* ─────────────────────────────────────────────────────────────────────
   * FREE SHIPPING BAR
   * ───────────────────────────────────────────────────────────────────── */
    function updateShippingBar(totalCents) {
      var threshold = window.satcFreeShipThreshold || 49900;
      var pct       = totalCents === 0 ? 0 : Math.min(100, Math.round(totalCents / threshold * 100));
      var remain    = Math.max(0, threshold - totalCents);
  
      var fillEl    = $('satc-ship-fill');
      var labelEl   = $('satc-ship-label');
      var pctEl     = $('satc-ship-pct');
      var trackEl   = $('satc-ship-track');
  
      if (fillEl)  fillEl.style.width = pct + '%';
      if (pctEl)   pctEl.textContent  = pct + '%';
      if (trackEl) trackEl.setAttribute('aria-valuenow', pct);
  
      if (labelEl) {
        if (totalCents === 0) {
          labelEl.innerHTML = 'Free shipping on orders over <strong>' + formatMoney(threshold) + '</strong>';
        } else if (remain > 0) {
          labelEl.innerHTML = 'Add <strong>' + formatMoney(remain) + '</strong> more for <strong>free shipping</strong>';
        } else {
          labelEl.innerHTML = '<strong style="color:#1a8a2e">&#10003; Free shipping unlocked!</strong>';
        }
      }
    }

  /* ─────────────────────────────────────────────────────────────────────
   * UPSELL — add upsell product to cart
   * ───────────────────────────────────────────────────────────────────── */
  window.satcAddUpsell = function (btn) {
    if (btn.classList.contains('is-added')) return;
    var variantId = btn.dataset.variant;
    var title     = btn.dataset.title;
    btn.disabled  = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(function () {
      btn.textContent = '&#10003; Added';
      btn.innerHTML   = '&#10003; Added';
      btn.classList.add('is-added');
      showToast((title || 'Item') + ' added', false);
      satcRefreshDrawer();
    })
    .catch(function (err) {
      console.error('[satc] upsell error', err);
      btn.disabled    = false;
      btn.textContent = '+ Add';
    });
  };

  /* ─────────────────────────────────────────────────────────────────────
   * RECENTLY VIEWED — track + render
   * ───────────────────────────────────────────────────────────────────── */
  function trackRecentlyViewed() {
    if (!window.satcProductId) return;
    var product = {
      id:    window.satcProductId,
      title: document.title.split('–')[0].trim(),
      price: window.satcVariants && window.satcVariants[0]
               ? window.satcVariants[0].price : 0,
      url:   window.location.pathname,
      image: (function () {
        var img = document.querySelector('.product__media img, .product-single__photo img, [data-product-featured-image]');
        return img ? img.src.replace(/(\?.*)?$/, '?width=200') : '';
      }()),
    };

    try {
      var viewed = JSON.parse(localStorage.getItem(CONFIG.rvKey) || '[]');
      viewed = viewed.filter(function (p) { return p.id !== product.id; });
      viewed.unshift(product);
      if (viewed.length > CONFIG.rvMax) viewed = viewed.slice(0, CONFIG.rvMax);
      localStorage.setItem(CONFIG.rvKey, JSON.stringify(viewed));
    } catch (e) {
      // localStorage not available (private browsing etc.)
    }
  }

  function renderRecentlyViewed() {
    var wrap = $('satc-rv-wrap');
    var list = $('satc-rv-list');
    if (!wrap || !list) return;

    var viewed;
    try {
      viewed = JSON.parse(localStorage.getItem(CONFIG.rvKey) || '[]');
    } catch (e) {
      viewed = [];
    }

    // Exclude the product the user is currently viewing
    viewed = viewed.filter(function (p) { return p.id !== window.satcProductId; }).slice(0, 6);

    if (!viewed.length) { wrap.style.display = 'none'; return; }
    wrap.style.display = '';

    list.innerHTML = viewed.map(function (p, i) {
      return [
        '<div class="satc-rv-card">',
          '<a class="satc-rv-card__img-wrap" href="' + p.url + '">',
            '<img class="satc-rv-card__img"',
                 ' src="' + (p.image || '') + '"',
                 ' alt="' + (p.title || '').replace(/"/g, '&quot;') + '"',
                 ' width="100" height="100" loading="lazy">',
          '</a>',
          '<p class="satc-rv-card__name">' + (p.title || '') + '</p>',
          '<p class="satc-rv-card__price">' + formatMoney(p.price) + '</p>',
          '<button type="button" class="satc-rv-card__add"',
                  ' data-url="' + p.url + '"',
                  ' data-title="' + (p.title || '').replace(/"/g, '&quot;') + '"',
                  ' onclick="satcAddRecentlyViewed(this)">+ Add</button>',
        '</div>',
      ].join('');
    }).join('');
  }

  window.satcAddRecentlyViewed = function (btn) {
    if (btn.classList.contains('is-added')) return;
    var url   = btn.dataset.url;
    var title = btn.dataset.title;
    btn.disabled    = true;
    btn.textContent = 'Adding…';

    // Fetch product JSON to get first available variant
    fetch(url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = product.variants.find(function (v) { return v.available; })
                   || product.variants[0];
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1 }),
        });
      })
      .then(function () {
        btn.textContent = '&#10003; Added';
        btn.innerHTML   = '&#10003; Added';
        btn.classList.add('is-added');
        showToast((title || 'Item') + ' added', false);
        satcRefreshDrawer();
      })
      .catch(function (err) {
        console.error('[satc] recently viewed add error', err);
        btn.disabled    = false;
        btn.textContent = '+ Add';
      });
  };

  /* ─────────────────────────────────────────────────────────────────────
   * INIT
   * ───────────────────────────────────────────────────────────────────── */
  function init() {
    initTimer();
    initStickyBar();
    initVariantSync();
    trackRecentlyViewed();
    satcRefreshDrawer(); // seed drawer on page load
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
